const $ = window.jQuery
const slideshareObject = window.slideshare_object
const slideshow = slideshareObject.slideshow
const utils = slideshareObject.utils

const asyncFunc = window.requestIdleCallback || window.requestAnimationFrame

const getArrowHtml = (direction, label) =>
  `<button class="paddle paddle-${direction}"><i class="fa fa-chevron-${direction}"></i><span class="visually-hidden">${label}</span></button>`

const CAROUSEL_DEFAULT = {
  accessibility: true,
  focusOnChange: true,
  dots: false,
  infinite: false,
  nextArrow: getArrowHtml("right", "next"),
  prevArrow: getArrowHtml("left", "previous"),
  slidesToScroll: 7,
  slidesToShow: 7,
  rows: 0,
  responsive: [
    {
      breakpoint: 1068,
      settings: {
        slidesToScroll: 6,
        slidesToShow: 6,
      },
    },
    {
      breakpoint: 900,
      settings: {
        slidesToScroll: 4,
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToScroll: 2,
        slidesToShow: 2.5,
      },
    },
    {
      breakpoint: 400,
      settings: {
        slidesToScroll: 2,
        slidesToShow: 2,
      },
    },
  ],
}

const CAROUSEL_SPILLOVER = {
  ...CAROUSEL_DEFAULT,
  nextArrow: getArrowHtml("right", "next recommended Slideshows"),
  prevArrow: getArrowHtml("left", "previous recommended Slideshows"),
  slidesToScroll: 6,
  slidesToShow: 6,
  responsive: [
    {
      breakpoint: 1068,
      settings: {
        slidesToScroll: 4,
        slidesToShow: 4,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToScroll: 2,
        slidesToShow: 2.5,
      },
    },
  ],
}

CAROUSEL_SPILLOVER.responsive[1].settings.slidesToShow = 2 // override 2.5

const FADE_IN_ANIMATION = { animation: "fadein 0.4s forwards" }

function loadRecommender(recommender) {
  const $recommender = $(recommender)

  $recommender.find("img.lazy").each(function () {
    const src = $(this).data("src")
    $(this).css("visibility", "visible")
    $(this).attr("src", src)
  })

  $recommender.css(FADE_IN_ANIMATION)
}

function loadSlick() {
  const slickImport = import(/* webpackChunkName: "slick" */ "../vendor/slick.js")

  return slickImport.then(() => {
    $(".recommender-carousel.book-carousel")
      .show()
      .slick({
        ...CAROUSEL_DEFAULT,
        nextArrow: getArrowHtml("right", utils.i18n("slideview.recommended_carousel.related_books_carousel_next")),
        prevArrow: getArrowHtml("left", utils.i18n("slideview.recommended_carousel.related_books_carousel_previous")),
      })
    $(".recommender-carousel.audiobook-carousel")
      .show()
      .slick({
        ...CAROUSEL_DEFAULT,
        nextArrow: getArrowHtml("right", utils.i18n("slideview.recommended_carousel.related_audiobooks_carousel_next")),
        prevArrow: getArrowHtml(
          "left",
          utils.i18n("slideview.recommended_carousel.related_audiobooks_carousel_previous")
        ),
      })
    $(".spillover-carousel.for_you_carousel")
      .show()
      .slick({
        ...CAROUSEL_SPILLOVER,
        nextArrow: getArrowHtml("right", utils.i18n("slideview.recommended_carousel.similarity_carousel_next")),
        prevArrow: getArrowHtml("left", utils.i18n("slideview.recommended_carousel.similarity_carousel_previous")),
      })
    $(".spillover-carousel.also_liked_carousel")
      .show()
      .slick({
        ...CAROUSEL_SPILLOVER,
        nextArrow: getArrowHtml("right", utils.i18n("slideview.recommended_carousel.linked_in_carousel_next")),
        prevArrow: getArrowHtml("left", utils.i18n("slideview.recommended_carousel.linked_in_carousel_previous")),
      })
    $(".spillover-carousel.similar_to_carousel")
      .show()
      .slick({
        ...CAROUSEL_SPILLOVER,
        nextArrow: getArrowHtml(
          "right",
          utils.i18n("slideshow.foundation_slideview.recommended_carousel.semantic_carousel_next", {
            title: slideshow.title,
          })
        ),
        prevArrow: getArrowHtml(
          "left",
          utils.i18n("slideshow.foundation_slideview.recommended_carousel.semantic_carousel_previous", {
            title: slideshow.title,
          })
        ),
      })
    $(".spillover-carousel.more_from_user_carousel")
      .show()
      .slick({
        ...CAROUSEL_SPILLOVER,
        nextArrow: getArrowHtml(
          "right",
          utils.i18n("slideshow.foundation_slideview.recommended_carousel.more_from_user_carousel_next", {
            username: slideshow.user_name,
          })
        ),
        prevArrow: getArrowHtml(
          "left",
          utils.i18n("slideshow.foundation_slideview.recommended_carousel.more_from_user_carousel_previous", {
            username: slideshow.user_name,
          })
        ),
      })
    $(".spillover-carousel.featured_carousel")
      .show()
      .slick({
        ...CAROUSEL_SPILLOVER,
        nextArrow: getArrowHtml("right", utils.i18n("slideview.recommended_carousel.featured_carousel_next")),
        prevArrow: getArrowHtml("left", utils.i18n("slideview.recommended_carousel.featured_carousel_previous")),
      })
  })
}

function initRecommenders() {
  const $recommenders = $(".recommender-wrapper")

  let slickLoaded = false

  try {
    $recommenders.get().forEach((recommender) => {
      let observer

      const handleRecommender = () => {
        loadRecommender(recommender)

        observer.unobserve(recommender)
      }

      const observerCallback = ([observedElement]) => {
        if (!observedElement.isIntersecting) return

        if (!slickLoaded) {
          slickLoaded = true

          return loadSlick().then(function () {
            handleRecommender()
          })
        }

        handleRecommender()
      }

      observer = new IntersectionObserver(observerCallback)

      observer.observe(recommender)
    })
  } catch (error) {
    console.log("Error in recommendations:", error) // eslint-disable-line no-console

    $recommenders.css(FADE_IN_ANIMATION)
  }
}

asyncFunc(initRecommenders)
